export async function getAsyncData(key: string): Promise<string | null> {
  try {
    if (typeof window === "undefined") {
      return null;
    }
    const data = window.localStorage.getItem(key);

    return data ?? null;
  } catch (error) {
    return null;
  }
}

export function setAsyncData(key: string, value: string): void {
  try {
    if (typeof window === "undefined") {
      return;
    }
    window.localStorage.setItem(key, value);
  } catch (error) {}
}

export const storeTokenLocally = async (token: string): Promise<void> => {
  localStorage.setItem("sessionToken", token);
};

export const getStoredToken = async (): Promise<string | null> => {
  return localStorage.getItem("sessionToken");
};

export const removeStoredToken = async (): Promise<void> => {
  localStorage.removeItem("sessionToken");
};
